"use strict"

import {observable, action} from "mobx"
import {v4 as uuidv4} from "uuid"

class DeviceDialogStore {
	@observable isOpen = false
	@observable places = []
	@observable onlyDevice = false

	formRef = null

	@action open(place) {
		if (place) {
			this.onlyDevice = true
			this.formRef.$("cityName").value = place.city
			this.formRef.$("cityId").value = place.cityId
			this.formRef.$("street").value = place.street
		} else {
			this.onlyDevice = false
		}

		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
	}

	@action addDevice(form) {
		const values = form.values()

		if (this.places.length === 0) {
			this.places = [
				{
					cityId: values.cityId,
					city: values.cityName,
					street: values.street,
					devices: [
						{
							_id: uuidv4(),
							deviceId: values.device,
							device: values.deviceName,
							power: values.devicePower,
							capacity: values.deviceCapacity,
							catastral: values.deviceCadastralArea,
							parcel: values.deviceParcelNumber
						}
					]
				}
			]
		} else {
			const currPlace = this.places.find(
				(place) => place.cityId === values.cityId && place.street === (values.street || "").trim()
			)

			if (currPlace) {
				currPlace.devices.push({
					_id: uuidv4(),
					deviceId: values.device,
					device: values.deviceName,
					power: values.devicePower,
					capacity: values.deviceCapacity,
					catastral: values.deviceCadastralArea,
					parcel: values.deviceParcelNumber
				})

				const otherPlaces = this.places.filter(
					(place) => place.cityId !== values.cityId || place.street !== (values.street || "").trim()
				)

				otherPlaces.push(currPlace)

				this.places = otherPlaces
			} else {
				this.places.push({
					cityId: values.cityId,
					city: values.cityName,
					street: values.street,
					devices: [
						{
							_id: uuidv4(),
							deviceId: values.device,
							device: values.deviceName,
							power: values.devicePower,
							capacity: values.deviceCapacity,
							catastral: values.deviceCadastralArea,
							parcel: values.deviceParcelNumber
						}
					]
				})
			}
		}

		form.reset()

		this.close()
	}

	@action removePlace(place) {
		this.places = this.places.filter((pls) => pls.cityId !== place.cityId || pls.street !== (place.street || "").trim())
	}

	@action removeDevice(place, device) {
		this.places = this.places.map((pls) => {
			if (pls.cityId !== place.cityId && pls.street !== (place.street || "").trim()) {
				return pls
			} else {
				const newDevices = pls.devices.filter((dev) => dev._id !== device._id)

				return {
					city: place.city,
					cityId: place.cityId,
					street: place.street,
					devices: newDevices
				}
			}
		})
	}
}

var singleton = new DeviceDialogStore()
export default singleton

